import React from 'react'

export default function Logo() {
	return (
		<img className="header-logo" alt="unified logo" src="https://www.datocms-assets.com/3323/1528751538-white-logo-2.png" />
	)
}


// WEBPACK FOOTER //
// ./src/components/Logo.js